/**
CREATIVE CODING
---
Kill server : CTRL + C
Start server : npm run start
Final build : npm run build
---
*
*/

import * as dat from "dat.gui";

import AxL from "./axl";
import PoemPostcard from "./PoemPostcard.js";

export default class App {
  constructor() {
    this.axl = new AxL();
    this.poemPostcard = new PoemPostcard();

    this.axl.handshake().then(async data => {
      await this.poemPostcard.init();
      this.poemPostcard.initAxl(this.axl, data);
    })
  }
}
